import React from "react";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from "recharts";

const ReportChart = ({
  type = "line",
  data = [],
  xKey = "date",
  yKey = "value",
  series = [],
}) => {
  const hasData = Array.isArray(data) && data.length > 0;

  const resolvedSeries =
    series && series.length > 0 ? series : [{ dataKey: yKey, name: yKey }];

  return (
    <div className="report-chart">
      {!hasData ? (
        <div className="report-chart-empty">
          No chart data available for this period.
        </div>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          {type === "line" && (
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey={xKey} />
              <YAxis />
              <Tooltip />
              <Legend />
              {resolvedSeries.map((s) => (
                <Line
                  key={s.dataKey}
                  type="monotone"
                  dataKey={s.dataKey}
                  stroke="#4f46e5"
                  dot={false}
                />
              ))}
            </LineChart>
          )}

          {type === "bar" && (
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey={xKey} />
              <YAxis />
              <Tooltip />
              <Legend />
              {resolvedSeries.map((s) => (
                <Bar key={s.dataKey} dataKey={s.dataKey} fill="#4f46e5" />
              ))}
            </BarChart>
          )}

          {type === "pie" && (
            <PieChart>
              <Tooltip />
              <Legend />
              <Pie
                data={data}
                dataKey={yKey}
                nameKey={xKey}
                cx="50%"
                cy="50%"
                outerRadius={90}
                fill="#4f46e5"
                label
              >
                {data.map((_, idx) => (
                  <Cell key={`cell-${idx}`} fill="#4f46e5" />
                ))}
              </Pie>
            </PieChart>
          )}

          {type === "area" && (
            <AreaChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey={xKey} />
              <YAxis />
              <Tooltip />
              <Legend />
              {resolvedSeries.map((s) => (
                <Area
                  key={s.dataKey}
                  type="monotone"
                  dataKey={s.dataKey}
                  stroke="#4f46e5"
                  fill="#a5b4fc"
                />
              ))}
            </AreaChart>
          )}
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default ReportChart;
